import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { AppConfigService } from "@master/core/dist/core";
import { BaseService } from "./base.service";

@Injectable({
  providedIn: "root",
})
export class PrevisionService extends BaseService {
  constructor(
    private http: HttpClient,
    public appConfigService: AppConfigService
  ) {
    super(appConfigService);
  }

  createPrevision(dataTransport: any): Observable<any> {
    dataTransport.origin = this.appConfigService.getConfig().qrGeneratorConfig.originCenter;
    return this.http.post(`${this.getUrl()}/previsions`, dataTransport);
  }

  findPrevisionByTKNUM(TKNUM: string): Promise<any>{
    return this.http.post(`${this.getUrl()}/previsions/list`, {TKNUM}).toPromise();
  }

}
